import styled from 'styled-components'
import { Link } from 'react-router-dom'
import colors from 'globals/colors'

export const BackLink = styled(Link)`
  color: ${colors.waterBlue};
  font-size: 13px;
  text-decoration: underline;
`
